<div *ngIf="noReq == false && contractId != null" class="req-card-line border-5">
  <div class="req-card" *ngFor="let instReqName of reqAccKeys; trackBy: trackByRequirementName" [ngbTooltip]="instReqName"
          (click)="open(instReqName)"
          placement="top"
          autoClose="outside"
          [ngClass]="{'def-cursor': !interarctive}"> 
    <div class="position-relative d-flex justify-content-center align-items-center mb-2" style="width: 100%;">
      <span class="position-absolute badge rounded-pill text-bg-danger" style="color: white; z-index: 100; top: -8px; right: -8px; transform: none;">
        {{reqAccumulator[instReqName].length}}
      </span>
      <ng-template #servicePayForm>
        <div style="margin: 1vh 1vw 1vh 1vw;">
          <app-instreq-servpay-form-for-accumulator [installments]="reqAccumulator[selectedRequirement].installments" 
                                                    [contractRequirementId]="reqAccumulator[selectedRequirement][0]?.instReqState.contractRequirementId" 
                                                    (closeAction)="refresh($event)"
                                                    [reqName] = "selectedRequirement">
          </app-instreq-servpay-form-for-accumulator>
        </div>
      </ng-template>
      <fa-icon 
        [icon]="iconService.getIcon(reqAccumulator[instReqName][0]?.instReqState.requirementIcon)" 
        size="2x"
        style="opacity: 0.8; color: #2196f3;">
      </fa-icon>
    </div>
    <span class="req-style-text">
        {{instReqName}}
    </span>
  </div>
</div>


<div *ngIf="noReq == true || contractId == null" class="table-empty">
  <fa-icon [icon]="iconQuestion" size="3x" style="color: #6c757d; margin-bottom: 12px;"></fa-icon>
  <span style="text-align: center; color: #6c757d; font-weight: 500;">No hay servicios vencidos</span>
</div>